export default __webpack_public_path__ + "static/media/editIcon.bd3fa03a.svg";